import Vue from 'vue';
import * as menuService from '@/services/menu.service';
import { TrackingEventsEnum } from '@/enums';

const state = {
    isLoading: 0,
    categories: [],
    _productsMap: null
};

const mutations = {
    FETCH_START(state) {
        state.isLoading++;
    },
    FETCH_END(state) {
        state.isLoading--;
    },
    SAVE_MENU_CATEGORIES(state, payload) {
        state.categories = payload;

        state._productsMap = payload.reduce((map, category) => {
            category.products?.forEach(product => {
                if (product?.id) {
                    map[product.id] = product;
                }
            });
            return map;
        }, {});
    }
};

const getters = {
    isLoading(state) {
        return state.isLoading;
    },
    categories(state) {
        return state.categories;
    },
    products(state) {
        return (
            state.categories?.flatMap(category => category.products ?? []) ?? []
        );
    },
    categoryExists: state => id => {
        return state.categories.some(category => category.id === id);
    },
    productsMap(state) {
        if (!state.categories || !state.categories.length) {
            return null;
        }
        return state._productsMap;
    }
};

const actions = {
    async getMenuCategories(
        { commit, rootGetters },
        { id, lang = null, silent = false }
    ) {
        if (!silent) {
            commit('FETCH_START');
        }

        const isStoreDesigner = rootGetters['helpers/isStoreDesigner'];
        const isDebugMode = rootGetters['helpers/isDebugMode'];

        try {
            const showAll = isStoreDesigner || isDebugMode ? true : false;

            const { data } = await menuService.getMenuCategories(
                id,
                showAll,
                lang
            );

            const categories = data.categories.map(category => ({
                ...category,
                products: category.products.map(product => ({
                    ...product,
                    categoryPosId: category.deliverectId,
                    modifierGroups:
                        product?.modifierGroups?.map(
                            ({ id, index, nestedGroups, isNested }) => {
                                const fullGroup =
                                    data.modifierGroups?.[id] || {};

                                return {
                                    ...fullGroup,
                                    index,
                                    nestedGroups,
                                    isNested
                                };
                            }
                        ) || []
                }))
            }));

            commit('SAVE_MENU_CATEGORIES', categories);

            if (Vue.prototype.$analytics) {
                await Vue.prototype.$analytics.track(
                    TrackingEventsEnum.MENU_LOADED,
                    {
                        menuId: id
                    }
                );
            }
        } catch (e) {
            throw new Error(`API ${e}`);
        } finally {
            if (!silent) {
                commit('FETCH_END');
            }
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
